var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.63,
    height: 13.138,
    viewBox: "0 0 16.63 13.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Business_ID",
    "data-name": "Business ID",
    d: "M199.534,239a1.313,1.313,0,1,1,.385.928A1.313,1.313,0,0,1,199.534,239Zm1.313,2.626h0a1.75,1.75,0,0,0-1.75,1.751v1.313h3.5v-1.313a1.75,1.75,0,0,0-1.751-1.751Zm11.816-5.689v10.5a.438.438,0,0,1-.437.438H196.47a.438.438,0,0,1-.438-.437v-10.5a.438.438,0,0,1,.438-.438h6.5v-1.322a.437.437,0,0,1,.437-.438h1.873a.438.438,0,0,1,.438.438V235.5h6.5a.438.438,0,0,1,.437.438Zm-.875.438h-14.88V246h14.88Zm-2.188,7h-4.376a.438.438,0,1,0,0,.875H209.6a.438.438,0,1,0,0-.875Zm0-3.5h-4.376a.438.438,0,1,0,0,.875H209.6a.438.438,0,1,0,0-.875Zm-4.814-1.313a.437.437,0,0,0,.438.438H209.6a.438.438,0,1,0,0-.875h-4.376A.438.438,0,0,0,204.785,238.563Z",
    transform: "translate(-196.033 -233.74)",
    fill: "#ff7200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessId);
export default __webpack_public_path__ + "static/media/business_id.8a9dc61a58aceb34b0b8941fde35e263.svg";
export { ForwardRef as ReactComponent };